/**
 * @param {boolean} inited 
 * @returns {string}
 */
export function getMonthPayerBillingGroupPreviewsStatusStr(inited) {
  if(inited) {
    return 'inited';
  }
  return 'not inited';
}
